module.exports = __webpack_public_path__ + "static/media/img-4.6a800382.jpg";